import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';
export const CancelIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#e35205',
    width: props.width || '21',
    height: props.height || '21',
  };
  return (
    <svg {...svgProps} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3686 5.86848L15.1313 4.63123L10.5 9.2626L5.8686 4.63123L4.63135 5.86848L9.26272 10.4999L4.63135 15.1312L5.8686 16.3685L10.5 11.7371L15.1313 16.3685L16.3686 15.1312L11.7372 10.4999L16.3686 5.86848Z"
        fill={svgProps.fill}
      />
    </svg>
  );
};

CancelIcon.iconType = ICON_TYPES.CANCEL;
